/**
 * Wraps a theme change in the View Transitions API for a polygon reveal effect.
 * Falls back to an instant switch in browsers without support.
 */
export function setThemeWithTransition(setTheme: (theme: string) => void, theme: string): void {
  if (typeof document === 'undefined' || !document.startViewTransition) {
    setTheme(theme);
    return;
  }
  document.startViewTransition(() => {
    setTheme(theme);
  });
}
